import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Modal, Form } from 'semantic-ui-react'
import {
    FormTextFormField,
    SubmitCancelButtons,
} from 'elements'
import { FlexRowBetween } from 'components'
import { X } from 'phosphor-react'

const AssetTypeSchema = yup.object().shape({
    type: yup.string().required('Type is required'),
    description: yup.string().nullable(),
})

export const AssetTypeAddEditModal = ({
    open,
    onClose,
    data,
    loading,
}) => {
    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(AssetTypeSchema),
        defaultValues: {
            type: '',
            description: '',
        },
    })

    useEffect(() => {
        if (data && (data.id || data.AssetCategoryId)) {
            reset({
                type: data.type || '',
                description: data.description || '',
            })
        } else {
            reset({
                type: '',
                description: '',
            })
        }
    }, [data, reset])

    const submit = async (formData) => {
        await onClose(formData)
    }

    const handleCancel = () => {
        reset()
        onClose(null)
    }

    return (
        <Modal open={open} onClose={handleCancel} size="small">
            <Modal.Header>
                <FlexRowBetween>
                    <div style={{ fontWeight: 600, fontSize: '18px' }}>
                        {data?.id || data?.AssetCategoryId
                            ? 'Edit Asset Type'
                            : 'Add Asset Type'}
                    </div>
                    <X
                        className="pointer"
                        size={24}
                        onClick={handleCancel}
                    />
                </FlexRowBetween>
            </Modal.Header>
            <Modal.Content>
                <Form noValidate>
                    <Form.Group>
                        <FormTextFormField
                            control={control}
                            name="type"
                            label="Type"
                            placeholder="Enter asset type"
                            errors={errors.type}
                            required
                        />
                    </Form.Group>
                    <Form.Group>
                        <FormTextFormField
                            control={control}
                            name="description"
                            label="Description"
                            placeholder="Enter description"
                            errors={errors.description}
                        />
                    </Form.Group>
                    <div className="pt-1">
                        <SubmitCancelButtons
                            onSubmit={handleSubmit(submit)}
                            onCancel={handleCancel}
                            loading={loading}
                        />
                    </div>
                </Form>
            </Modal.Content>
        </Modal>
    )
}
